export const groupTypes = {
  PRIVATE: 'private',
  PUBLIC: 'public',
  EXPECT: 'expect',
}
